import CreateBulkEntities from '../CreateBulkEntities'

const CreateBulkCards = () => {
  return <CreateBulkEntities type="bulkCard" />
}
export default CreateBulkCards
